/** How long the read-only state lasts after the last refusal: the banner leaves by itself once the service is back. */
const READ_ONLY_MS = 300_000;

/**
 * Whether Supabase is refusing writes (P12, spec §18.4: a restricted project answers 402, a full one is read-only).
 * Set by every refusal mapped to `read_only`; ended by a write that goes through, or 5 minutes after the last refusal.
 * The canvas keeps working through the room meanwhile.
 */
function createServiceStatus() {
  const subs = new Set<() => void>();
  let readOnly = false;
  let timer: ReturnType<typeof setTimeout> | null = null;
  const set = (next: boolean) => {
    if (timer) clearTimeout(timer);
    timer = next ? setTimeout(() => set(false), READ_ONLY_MS) : null;
    if (next === readOnly) return;
    readOnly = next;
    subs.forEach((cb) => cb());
  };
  return {
    readOnly: () => readOnly,
    markReadOnly: () => set(true),
    writeOk: () => {
      if (readOnly) set(false);
    },
    clear: () => set(false),
    subscribe(cb: () => void) {
      subs.add(cb);
      return () => void subs.delete(cb);
    },
  };
}

export const serviceStatus = createServiceStatus();
